export default "__VITE_ASSET__BqDCKmh$__"